import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { PagedResult, DeckSize } from '../../models';
import { IBaseService } from '../BaseService';


export interface IDeckSizeService extends IBaseService<DeckSize, number> {
	getMultiple(ids: number[]): Promise<DeckSize[]>;
}


@injectable()
export class DeckSizeService implements IDeckSizeService {

	private cache: Promise<DeckSize[]>;


	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) { }

	public get(id: number): Promise<DeckSize> {
		const url = `${this.settings.baseUrl}${this.settings.deckSizeUrl}/${id}`;
		return this.httpClient.get<DeckSize>(url);
	}

	public getMultiple(ids: number[]): Promise<DeckSize[]> {
		const url = `${this.settings.baseUrl}${this.settings.deckSizeUrl}/multiple/${ids.join(',')}`;
		return this.httpClient.get<DeckSize[]>(url);
	}

	public page(pageIndex: number, pageSize: number): Promise<PagedResult<DeckSize>> {
		const url = `${this.settings.baseUrl}${this.settings.deckSizeUrl}/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<DeckSize>>(url);
	}

	public list(): Promise<DeckSize[]> {
		const url = `${this.settings.baseUrl}${this.settings.deckSizeUrl}`;
		if (!this.cache) { this.cache = this.httpClient.get<DeckSize[]>(url); }
		return this.cache;
	}

	public save(model: DeckSize): Promise<DeckSize> {
		this.cache = null; // INVALIDATE CACHE
		const payload = {
			id: model.id,
			name: model.name,
			description: model.description,
			sortBy: (model.sortBy != null) ? parseInt(model.sortBy.toString(), null) : null,
		};

		let url = `${this.settings.baseUrl}${this.settings.deckSizeUrl}`;
		if (model.id !== null && model.id !== undefined) {
			url += `/${model.id}`;
			return this.httpClient.put(url, payload);
		}
		return this.httpClient.post(url, payload);
	}

	public delete(id: number): Promise<any> {
		this.cache = null; // INVALIDATE CACHE
		const url = `${this.settings.baseUrl}${this.settings.deckSizeUrl}/${id}`;
		return this.httpClient.delete(url);
	}

}
